import {useAuthenticationStore} from "../../store/auth.ts";
import {LoginPage} from "./LoginPage.tsx";
import {useEffect, useState} from "react";

type AuthGuardProps = {
    children: React.ReactNode;
}

export const AuthGuard = ({children}: AuthGuardProps) => {

    const {isAuthenticated, setAuthenticated} = useAuthenticationStore();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        console.log("AuthGuard", isAuthenticated);
        fetch("/cartright/cartrightTMS.nsf/api.xsp/api/integration/checkauth")
            .then(async res => {
                const text = await res.text()
                if (text.startsWith("{")) {
                    const json = JSON.parse(text)
                    console.log(json);
                    if (json.authenticated === true) {
                        setAuthenticated(true);
                    }
                }else{
                    console.log(text);
                }

            })
            .catch(e => console.error(e))
            .finally(() => setIsLoading(false));

    }, [isAuthenticated]);

    if (isLoading) {
        return <div>LOADING:::::::</div>
    }

    if (isAuthenticated) {
        return <>{children}</>
    }

    return <LoginPage/>
}